import { useSelector } from 'react-redux';

export const WRITE_REFERRAL_PERIOD = 'write:referral_period';

export const usePermissionCheck = (permissionToCheck) => {
    const permissions = useSelector((state) => state.auth.permissions);
    return permissions?.includes(permissionToCheck) ?? false;
};
